'use client';
import { Carousel, CarouselContent, CarouselItem } from '../ui/carousel';
import Image from '../Image';
import { useLocale } from 'next-intl';

import { IBanner } from '@/src/app/[locale]/(cms)/CMSComponents/services/types';
import RenderDestination from '@/src/app/[locale]/(cms)/CMSComponents/Components/RenderDestination';

export type NumberOfImages = 'oneImage' | 'twoImages' | 'threeImages' | 'fourImages';

type TProps = {
  sliders: IBanner[];
  className?: string;
  numberOfImages: NumberOfImages;
  showingSectionTitle?: boolean;
  showingSectionDescription?: boolean;
  name?: string;
  description?: string;
  branchId?: number;
};

type ImageConfig = {
  class: string;
  sizes: string;
};

const imageConfig: Record<NumberOfImages, ImageConfig> = {
  oneImage: {
    class: 'basis-1/1 aspect-4/1',
    sizes: '(min-width: 1420px) 1290px, calc(90.27vw + 28px)',
  },
  twoImages: {
    class: 'basis-[calc(50%-.5rem)] aspect-3/1.25',
    sizes: '(min-width: 1420px) 632px, 45.09vw',
  },
  threeImages: {
    class: 'basis-[calc(33.333%-.5rem)] aspect-2/1',
    sizes: ' 33vw',
  },
  fourImages: {
    class: `basis-[calc(25%-.5rem)] aspect-square`,
    sizes: '(min-width: 1520px) 322px, 21.67vw',
  },
};

function ImagesCarousel({ sliders, className, numberOfImages, branchId }: TProps) {
  const locale = useLocale();
  const config = imageConfig[numberOfImages];

  return (
    <Carousel
      className="w-full"
      opts={{
        slidesToScroll: 'auto',
        dragFree: true,
        direction: locale === 'ar' ? 'rtl' : 'ltr',
      }}
    >
      <CarouselContent className="mx-0 gap-2">
        {sliders.map((item, index) => (
          <CarouselItem
            key={index}
            className={`h-full w-full p-0 ${config.class} ${className ?? ''}`}
          >
            <RenderDestination destination={item.Destination} branchId={branchId}>
              <div className={`relative h-full w-full overflow-hidden rounded-2xl`}>
                <Image
                  fill
                  alt={item.EnglishImage}
                  src={locale === 'ar' ? item.ArabicImage : (item.EnglishImage ?? '')}
                  className={`flex-1 rounded-2xl object-cover object-center`}
                  sizes={config.sizes}
                />
              </div>
            </RenderDestination>
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
}

export default ImagesCarousel;
